// extracted by mini-css-extract-plugin
export default {"headerWrap":"index_headerWrap_INp-W","footerWrap":"index_footerWrap_ZGXSK","main":"index_main_S--yp","subNav":"index_subNav_d5DdS"};